<template>
    <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Tipo Finalização:"
    id="selectFinalizacao"
    placeholder="Selecione o tipo de finalização"
    :multiple="False"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'

export default {
  name: 'NxSelectTipoFinalizacao',
  mixins: [ useReactiveModelMixin('value') ],
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadFinalizacao()
  },
  methods: {
    onLoadFinalizacao () {
      AtendimentoRepository.GetTipos()
        .then((response) => {
          const { data } = response
          this.listOptions = data.tipos.map(tipo => ({ text: tipo, value: tipo }))
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Finalização', 'Erro')
          console.error(err)
        })
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectTipoFinalizacao.vue